module.exports = __webpack_public_path__ + "static/media/background-login.50a4993b.jpg";